import ColorPicker from "@/shared/forms/ColorPicker";
import NewRangePicker from "@/shared/forms/NewRangePicker";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@mui/material";
import dayjs from "dayjs";
import { ReactElement, cloneElement, useState } from "react";
import LabelWrapper from "../../root/LabelWrapper";
import { ProjectNote } from "../Project";

/** Bearbeitet eine Notiz lokal; erst der zentrale Projekt-Speichern-Button persistiert sie. */
export default function ProjectNoteDialog({ note, opener, onSave }: { note?: ProjectNote; opener: ReactElement<any>; onSave: (note: ProjectNote) => void }) {
  const [open, setOpen] = useState(false);
  const initial = (): ProjectNote => note ?? {
    id: 0,
    clientId: self.crypto.randomUUID(),
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
    title: "",
    description: "",
    color: "#8bc34a",
    visibleForPolier: true,
  };
  const [state, setState] = useState<ProjectNote>(initial);
  const show = () => { setState(initial()); setOpen(true); };

  return <>
    {cloneElement(opener, { onClick: show })}
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Projektnotiz</DialogTitle>
      <DialogContent sx={{ p: 0, display: "flex", flexDirection: "column" }}>
        <LabelWrapper label="Zeitraum">
          <NewRangePicker small value={[dayjs(state.startDate), dayjs(state.endDate)]} onChange={([start, end]) => setState(s => ({
            ...s,
            startDate: start?.format("YYYY-MM-DD") ?? "",
            endDate: end?.format("YYYY-MM-DD") ?? "",
          }))} />
        </LabelWrapper>
        <LabelWrapper label="Titel">
          <div style={{ display: "flex", alignItems: "stretch" }}>
            <TextField size="small" fullWidth value={state.title} onChange={e => setState(s => ({ ...s, title: e.target.value }))} />
            <ColorPicker size="small" value={state.color} onChange={color => setState(s => ({ ...s, color }))} />
          </div>
        </LabelWrapper>
        <LabelWrapper label="Beschreibung">
          <TextField size="small" fullWidth multiline minRows={4} value={state.description} onChange={e => setState(s => ({ ...s, description: e.target.value }))} />
        </LabelWrapper>
        <LabelWrapper label="Sichtbar für Polier">
          <TextField select size="small" fullWidth value={state.visibleForPolier ? "yes" : "no"} onChange={e => setState(s => ({ ...s, visibleForPolier: e.target.value === "yes" }))}>
            <MenuItem value="yes">Ja</MenuItem><MenuItem value="no">Nein</MenuItem>
          </TextField>
        </LabelWrapper>
      </DialogContent>
      <DialogActions>
        {note ? <Button color="error" onClick={() => { onSave({ ...state, deleted: true }); setOpen(false); }}>Löschen</Button> : null}
        <Button onClick={() => setOpen(false)}>Abbrechen</Button>
        <Button variant="contained" disabled={!state.title.trim() || !state.startDate || !state.endDate || state.startDate > state.endDate} onClick={() => { onSave(state); setOpen(false); }}>Übernehmen</Button>
      </DialogActions>
    </Dialog>
  </>;
}
